import React from 'react'

import { PriceString } from '@fourthwall/components'

import type { GiftCard } from '../../GiftCards.types'
import { getGiftCardTitle } from '../../utils/getGiftCardTitle'
import { isGiftCardSingle } from '../../utils/isGiftCardSingle'
import * as S from './GiftCardTableCell.styled'

type GiftCardTableCellProps = {
  giftCard: GiftCard
}

export const GiftCardTableCell = ({ giftCard }: GiftCardTableCellProps) => {
  const renderGiftCardPrice = () => {
    if (isGiftCardSingle(giftCard)) {
      return <PriceString {...giftCard.initialAmount} />
    }

    return (
      <PriceString
        value={giftCard.initialAmount.value / giftCard.codes.length}
        currency={giftCard.initialAmount.currency}
      />
    )
  }

  const renderGiftCardSummary = () => {
    if (isGiftCardSingle(giftCard)) {
      return <>{renderGiftCardPrice()} gift card</>
    }

    return (
      <>
        {giftCard.codes.length} x {renderGiftCardPrice()} gift card
      </>
    )
  }

  return (
    <div>
      <S.Title>{getGiftCardTitle(giftCard)}</S.Title>
      <S.Summary>{renderGiftCardSummary()}</S.Summary>
    </div>
  )
}
